import React, { useState, useEffect } from "react";
import BasicInput from "../../components/inputs/basicInput/basicInput";
import Btn from "../../components/Btn/Btn";
import { useNavigate, useLocation } from "react-router-dom"; // Для перенаправления
import { login, getContractsFullByID } from "../../api/auth"; // Импорт API функции
import "./authpanel.css";
import BasicPanel from "../../components/panels/basicPanel/basicPanel";
import { useLanguage } from "../../context/localeContext";
import { callback } from "../../api/auth";
import { getMaxIdFromStorage, getMaxIdFromUrl, getTgIdFromStorage, getTgIdFromUrl, useMessenger } from "../../context/messengerContext";
import { hasUserId } from "../../utils/userIdPayload";
import BasicCheckbox from "../../components/basicCheckbox/basicCheckbox";
import validateForm from "./validators/validatorHelper";
import { Loader, Message, useToaster } from "rsuite";
import FirstTimeModal from "../../components/firstTimeModal/firstTimeModal";
import PrivacyPolicyModal from "../../components/privacyPolicyModal/privacyPolicyModal";
import { useManualModal } from "../../hooks/useFirstTimeModal";
import { useTranslation } from "react-i18next";
import { subscribeToPush, unsubscribeFromPush } from "../../utils/pushSubscription";

export default function AuthPanel() {
  const { t } = useTranslation('basic');
  const navigate = useNavigate();
  const location = useLocation();
  const toaster = useToaster();
  const { userId, platform } = useMessenger();
  const { language } = useLanguage();
  const searchParams = new URLSearchParams(window.location.search);
  const authUserId = userId || (platform === 'max'
    ? getMaxIdFromUrl() || getMaxIdFromStorage()
    : getTgIdFromUrl() || getTgIdFromStorage());

  // Manual modal control
  const { openModal, getModalProps } = useManualModal();

  const urlSearchParams = new URLSearchParams(window.location.search);

  const type = urlSearchParams.get('type') || searchParams.get('type');
  const first = urlSearchParams.get('first') || searchParams.get('first') || location.state?.first;
  const test = urlSearchParams.get('test') || searchParams.get('test');

  // // Получаем `first` из URL или sessionStorage
  // const firstParam = searchParams.get("first");
  // const storedFirst = sessionStorage.getItem("first");
  // const first = firstParam || storedFirst;

  // Загружаем сохраненные данные из sessionStorage
  const [identifier, setIdentifier] = useState(sessionStorage.getItem("identifier") || "");
  const [password, setPassword] = useState("");
  const [contractNumber, setContractNumber] = useState(sessionStorage.getItem("contractNumber") || location.state?.contract_number || "");
  const [checkboxChecked, setCheckboxChecked] = useState(sessionStorage.getItem("checkboxChecked") === "true");
  const [errors, setErrors] = useState({});
  const [startTime, setStartTime] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [hasNoContracts, setHasNoContracts] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);

  useEffect(() => {
    sessionStorage.removeItem("password");
  }, []);


  // При открытии экрана логина отписываем устройство от push (выход из аккаунта / смена устройства)
  useEffect(() => {
    unsubscribeFromPush().catch(() => {});
  }, []);

  useEffect(() => {
    if (!authUserId) return;
    getContractsFullByID({ platform, userId: authUserId })
      .then(contracts => setHasNoContracts(contracts.length === 0))
      .catch(() => setHasNoContracts(true));
  }, [authUserId, platform]);


  // Функция для обновления sessionStorage при изменении инпутов
  const handleInputChange = (setter, field, persist = true) => (value) => {
    const trimmedValue = value?.trim() || "";
    setter(trimmedValue);
    if (persist) {
      sessionStorage.setItem(field, trimmedValue);
    }
  };

  const handleCheckboxChange = (value) => {
    setCheckboxChecked(value);
    sessionStorage.setItem("checkboxChecked", value);
  };

  const handleLogin = async () => {
    setLoading(true);

    if (!hasUserId(authUserId)) {
      toaster.push(
        <Message type="error" showIcon>Не удалось определить пользователя. Пожалуйста, откройте приложение заново.</Message>,
        { placement: "topCenter", duration: 4000 }
      );
      setLoading(false);
      return;
    }

    let errors = validateForm(0, {
      identifier,
      password,
      contractNumber,
      first: hasNoContracts,
      checkboxChecked
    });

    if (Object.keys(errors).length) {
      toaster.push(
        <Message type="error" showIcon>{t('not_all_fields_filled')}</Message>,
        { placement: "topCenter", duration: 3000 }
      )
      setErrors(errors);
      setLoading(false);
      return;
    }

    try {
      console.log(identifier, contractNumber, language, authUserId);
      console.log('platform', platform);
      const response = await login({
        platform,
        userId: authUserId,
        login: identifier,
        password,
        number: contractNumber,
        language,
      });

      if (!response || response.error) {

        let err_msg;
        
        if (response?.result?.error == "contract_error") {
          err_msg = t('contract_not_found');
        } else if (response?.result?.error) {
          if (response?.result?.error == "error_cdek_already_auth") {
            err_msg = t('contract_different_keys');
          } else if (response?.result?.error === "error_cdek_invalid_response") {
            err_msg = t('cdek_service_unavailable');
          } else {
            err_msg = response.result.error;
          }
        } else {
          err_msg = t('integration_keys_error');
        }

        toaster.push(
          <Message type="error" showIcon>{err_msg}</Message>,
          { placement: "topCenter", duration: 3000 }
        )
        return;
      }

      if (response.need_contact || test) {
        navigate("/auth_contact", {
          state: {
            _login: identifier,
            password,
            contract_number: contractNumber,
            language,
            access_token: response.access_token,
            first
          },
        });
      } else if (response.access_token) {
        await callback({
          platform,
          userId: authUserId,
          access_token: response.access_token,
          contract_number: contractNumber,
          language: language || null,
          first: first,
          session: {
            start_time: startTime.toISOString(),
            total_time: new Date().getTime() - startTime.getTime()
          }
        }).then(() => {
          subscribeToPush(platform, authUserId);
          sessionStorage.clear();
          navigate('/menu');
        });
      }
    } catch (e) {
      console.error(e);
      toaster.push(
        <Message type="error" showIcon>{t('integration_keys_error')}</Message>,
        { placement: "topCenter", duration: 3000 }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authPanelWrapper">      
      <BasicPanel className="authPanel">
        <div className="authRows">
          <h2 className="heading-h4">{t('authorization')}</h2>

          <BasicInput
            placeholder={t('identifier')}
            error={errors.identifier}
            value={identifier}
            onChange={handleInputChange(setIdentifier, "identifier")}
          />
          <BasicInput
            placeholder={t('password')}
            error={errors.password}
            isPassword={true}
            value={password}
            onChange={handleInputChange(setPassword, "password", false)}
          />
          <BasicInput
            placeholder={t('contract_number_label')}
            error={errors.contractNumber}
            value={contractNumber}
            onChange={(e) => {
              const trimmedValue = e?.trim()?.toUpperCase() || "";
              setContractNumber(trimmedValue);
              sessionStorage.setItem("contractNumber", trimmedValue);
            }}
          />

            {hasNoContracts && (
            <BasicCheckbox
            error={errors.checkboxChecked}
            checked={checkboxChecked}
            onChange={handleCheckboxChange}
            label={
              <>
                {t('agree_terms_prefix')}{' '}
                <span
                  style={{ color: '#1675e0', textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPrivacyModalOpen(true); }}
                >
                  {t('terms_of_use')}
                </span>
                {t('agree_terms_suffix') ? ' ' + t('agree_terms_suffix') : ''}
              </>
            }
            style={{ color: errors.checkboxChecked ? "red" : "black" }}
            />
          )}


          <Btn
            text={!loading ? t('login') : <Loader size="xs" />}
            disabled={loading}
            width="100%"
            className="authSubmitButton"
            onClick={handleLogin}
          />

          {/* Help link */}
          <div style={{ marginTop: '1rem', textAlign: 'center' }}>
            <span
              style={{ cursor: 'pointer', color: 'red', textDecoration: 'none' }}
              onClick={openModal}
            >
              {t('how_to_auth')}
            </span>
          </div>
        </div>
      </BasicPanel>
      
      {/* Manual First Time Modal */}
      {(() => {
        const modalProps = getModalProps();
        return modalProps ? <FirstTimeModal {...modalProps} /> : null;
      })()}

      <PrivacyPolicyModal
        open={privacyModalOpen}
        onClose={() => setPrivacyModalOpen(false)}
        language={language}
      />
    </div>
  );
}
